// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 180 ? "App" : chunkId) + "." + {"180":"b431d0e2","453":"2b9d46ed"}[chunkId] + ".chunk.js";
};